import { lazy } from "react";
import { RouterItemType } from "@/app/index";
import { serviceServicesApi } from "@/services/services";
import { AppointmentsListType } from "@/schemas/index";

const LayoutPageRequests = lazy(() => import("./layout/index"));

export type LoaderDataType = AppointmentsListType;

export const loaderDataRequests = async () => {
  try {
    const appointments = await serviceServicesApi.fetchAppointments();
    return appointments;
  } catch (error) {
    console.error(error);
    throw new Error("APPOINTMENTS_NOT_FOUND");
  }
};

export const routerPageRequests: RouterItemType = {
  path: "/service/requests",
  authorize: true,
  element: <LayoutPageRequests />,
  loader: loaderDataRequests,
};
